



















// @ is an alias to /src
import { Component } from "vue-property-decorator";
import Dialog from "@/components/Dialog.vue";
import ErrorList from "@/components/ErrorList.vue";
import HacoCommon from "../HacoCommon";
import CustomEditComp from "@/components/CustomEditComp.vue";
@Component({
  components: {
    CustomEditComp,
    Dialog,
    ErrorList
  }
})
export default class CustomEdit extends HacoCommon {
  // put something
}
